import React, { useRef } from 'react'
import ApiGateway from 'theme/api/api-gateway'
import { useFirebaseService } from 'theme/services/firebase-service'
import { useAuthService } from 'theme/services/auth/auth-service'

// eslint-disable-next-line react/display-name
const withToggleFavouriteSession = (WrappedComponent) => (props) => {
  const firebase = useFirebaseService()
  const authService = useAuthService()
  const user = authService?.user
  const taskQueueFree = useRef(true)

  const toggleFavourite = (sessionID, conferenceId, isFavourite) => {
    if (!authService) {
      return
    }

    if (!user) {
      authService.openLoginModal()
      return
    }

    if (!taskQueueFree.current || isFavourite === null) {
      return
    }

    taskQueueFree.current = false

    const clearTaskQueue = () => {
      taskQueueFree.current = true
    }

    if (isFavourite) {
      ApiGateway.removeFavouriteSession(firebase, user.uid, sessionID, clearTaskQueue)
    } else {
      ApiGateway.setFavouriteSession(firebase, user.uid, sessionID, conferenceId, clearTaskQueue)
    }
  }

  return <WrappedComponent {...props} toggleFavourite={toggleFavourite} />
}

export default withToggleFavouriteSession
